module.exports = __webpack_public_path__ + "static/media/finalCSV.3e02df65.csv";